import React from 'react';
import styled from 'styled-components';
import { TabTextContent } from './TabTextContent';
import { TabImageContent } from './TabImageContent';
import { TabVideoContent } from './TabVideoContent';
import media from '../../../utils/media';
const Container = styled.div `
  box-sizing: border-box;
  width: 100%;
  min-height: 510px;
  text-align: center;
  outline: none;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  ${media.mobile} {
    min-height: auto;
  }
`;
export const TabPanel = ({ selectedIndex, itemId, children }) => {
    if (!children) {
        return null;
    }
    return (React.createElement(Container, { role: "tabpanel", id: `panel-${selectedIndex}-${itemId}`, "aria-labelledby": `tab-${selectedIndex}-${itemId}` }, children));
};
export const generateTabContent = (tabItem) => {
    const contentType = tabItem.fields.contentType.value;
    let content = null;
    if (contentType === 'Text') {
        content = React.createElement(TabTextContent, { fields: tabItem.fields.items[0].fields });
    }
    else if (contentType === 'Image') {
        content = React.createElement(TabImageContent, { fields: tabItem.fields.items[0].fields });
    }
    else if (contentType === 'Video') {
        content = React.createElement(TabVideoContent, { fields: tabItem.fields.items[0].fields });
    }
    return content;
};
